<template>
<v-container>
  <v-row
  align="center"
  justify="center">
      <v-col
      >
      <div class="containerdiv">
        <img border="0" :src="owls[selected_owl].src" alt="Owl" :width="128*2"/>
        <img class="cornerimage" border="0" :src="accessoirs_head[selected_head].src_front" alt="" :width="128*2"/>
        <img class="cornerimage" border="0" :src="accessoirs_body[selected_body].src_front" alt="" :width="128*2"/>
      </div>       
      </v-col>

      <v-col
       >
          <v-select
          :items="owls"
          :item-text="x=>x.name"
          :item-value="x=>x.id"
          v-model="selected_owl"
          label="Owl Color"
          class="styled-select"
        ></v-select>

         <v-select
          :items="accessoirs_head"
          :item-text="x=>x.name"
          :item-value="x=>x.id"
          v-model="selected_head"
          label="Head"
          class="styled-select"
        ></v-select>

        <v-select
          :items="accessoirs_body"
          :item-text="x=>x.name"
          :item-value="x=>x.id"
          v-model="selected_body"
          class="styled-select"
          label="Body"
        ></v-select>

       
        </v-col>
  </v-row>
</v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { Color } from '../enums';

import pinkOwl from '../assets/img/owl-pink-front.png';
import blueOwl from '../assets/img/owl-blue-front.png';
import purpleOwl from '../assets/img/owl-purple-front.png';
import orangeOwl from '../assets/img/owl-orange-front.png';

export default {
  name: 'OwlSelector',
  data() {
    return {
      owls: [
        {
          src: blueOwl,
          color: Color.BLUE,
          name: 'Blue'
        },
        {
          src: pinkOwl,
          color: Color.PINK,
          name: 'Pink'
        },
        {
          src: orangeOwl,
          color: Color.ORANGE,
          name: 'Orange'
        },
        {
          src: purpleOwl,
          color: Color.PURPLE,
          name: 'Purple'
        },
      ],
      
    };
  },
  computed: {
    selected_owl: {
      get() {
        let i = 0;
        for (let owl of this.owls) {
          if (owl.color === this.$store.state.user.owlColor) {
            return i;
          }
          i++;
        };
        console.warn('Color not found:', this.$store.state.user.owlColor);
        return 0;
      },
      set(v) {
        this.$store.state.user.owlColor = this.owls[v].color;
        this.updateUser();
      }
    },
    selected_head: {
      get() {
        return this.$store.state.user.headAccessoir; 
      },
      set(v) {
        this.$store.state.user.headAccessoir = v; //TODO: probably should use commit for this
        this.updateUser();
      }
    },
    selected_body: {
      get() {
        return this.$store.state.user.bodyAccessoir;
      },
      set(v) {
        this.$store.state.user.bodyAccessoir = v;
        this.updateUser();
      }
    },
    ...mapState('assets', ['accessoirs_body', 'accessoirs_head'])
  },
  methods: {
    ...mapActions('game', ['updateUser']),
  },
  mounted() {
    this.owls.forEach((owl,i) => {
      owl.id=i;
    }),
    this.accessoirs_head.forEach((acc,i) => {
      acc.id=i;
    }),
    this.accessoirs_body.forEach((acc,i) => {
      acc.id=i;
    })
  },
};
</script>

<style>
.containerdiv { float:right; position: relative; } 
.cornerimage { position: absolute; top: 0; right: 0; } 

.styled-select {
  width: 200px
}
</style>